
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentTitle from '@/components/TopContentTitle.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentCautionList from '@/components/TopContentCautionList.vue';
import TopContentCheck from '@/components/TopContentCheck.vue';

@Component({
  components: {
    PageHeader,
    TopFooterButton,
    TopContentTitle,
    TopContentText,
    TopContentCautionList,
    TopContentCheck
  }
})
export default class PersonalInformation extends Vue {
  private isChecked: boolean = false;

  // 次のページへ行く
  private async next(): Promise<void> {
    this.$router.push({ name: 'pass-vaccine-select-document' });
  }
}
